import { render, staticRenderFns } from "./RporteVentasPedidosPagos.vue?vue&type=template&id=b4bf6126"
import script from "./RporteVentasPedidosPagos.vue?vue&type=script&lang=js"
export * from "./RporteVentasPedidosPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports